import React from 'react';
import Header from '../components/Header';
import InvestorRelationsDocs from '../components/InvestorRelationsDocs';
import Footer from '../components/Footer';

const InvestorRelationsPage = () => {
  return (
    <div className="App">
      <Header />
      <InvestorRelationsDocs />
      <Footer />
    </div>
  );
};

export default InvestorRelationsPage;
